import { render, staticRenderFns } from "./assembly-order.vue?vue&type=template&id=5875186c&scoped=true&"
import script from "./assembly-order.vue?vue&type=script&lang=js&"
export * from "./assembly-order.vue?vue&type=script&lang=js&"
import style0 from "./assembly-order.vue?vue&type=style&index=0&id=5875186c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5875186c",
  null
  
)

export default component.exports